import Resource from '../Resource'

export default class AttachmentResource extends Resource {
    base64ToBlob(base64Image, fileName) {
        if (!base64Image) {
            return null
        }

        // .replace('image/png', 'image/octet-stream')
        let blobBin = atob(base64Image.split(',')[1])
        let array = []

        for (let i = 0; i < blobBin.length; i++) {
            array.push(blobBin.charCodeAt(i))
        }
        let file = new Blob([new Uint8Array(array)], { type: 'image/png' })
        file.name = fileName

        return file
    }

    async blobToBase64(blob) {
        let base64Image

        await new Promise((resolve) => {
            let reader = new FileReader()

            reader.onload = function() {
                let dataUrl = reader.result
                let base64 = dataUrl.split(',')[1]
                base64Image = base64
            }
            reader.readAsDataURL(blob)
            resolve()
        }).catch(() => {
        })

        return base64Image
    }

    async fileToBase64(file) {
        let base64
        if (!file) {
            return null
        }

        await new Promise((resolve, reject) => {
            const reader = new FileReader()
            reader.readAsDataURL(file)
            reader.onload = () => {
                base64 = reader.result
                resolve()
            }
            reader.onerror = error => reject(error)
        })
        return base64
    }

    async thumbnailify(base64Image) {
        let thumbnailBytes

        await new Promise((resolve) => {
            const thumbnailSize = 200
            let img = new Image()

            img.onload = function() {
                let width = img.width
                let height = img.height
                let canvas = document.createElement('canvas')
                let ctx = canvas.getContext('2d')

                canvas.width = canvas.height = thumbnailSize

                ctx.drawImage(
                    img,
                    width > height ? (width - height) / 2 : 0,
                    height > width ? (height - width) / 2 : 0,
                    width > height ? height : width,
                    width > height ? height : width,
                    0, 0,
                    thumbnailSize, thumbnailSize
                )

                thumbnailBytes = canvas.toDataURL()
                resolve()
            }

            img.src = base64Image
        }).catch(() => {
        })

        return thumbnailBytes
    }

    async thumbnailifyVideo(base64Video) {
        let thumbnailBytes

        await new Promise((resolve, reject) => {
            const thumbnailSize = 200
            let video = document.createElement('video')

            video.onloadedmetadata = function() {
                let duration = this.duration

                // Chrome bug: https://bugs.chromium.org/p/chromium/issues/detail?id=642012
                // If it is necessary we can use this package: https://www.npmjs.com/package/get-blob-duration
                if (duration === Infinity) {
                    this.currentTime = 0
                } else {
                    this.currentTime = this.duration / 2
                }
            }

            video.onseeked = function(e) {
                let width = video.videoWidth
                let height = video.videoHeight
                let canvas = document.createElement('canvas')
                let ctx = canvas.getContext('2d')

                canvas.width = canvas.height = thumbnailSize

                ctx.drawImage(
                    video,
                    width > height ? (width - height) / 2 : 0,
                    height > width ? (height - width) / 2 : 0,
                    width > height ? height : width,
                    width > height ? height : width,
                    0, 0,
                    thumbnailSize, thumbnailSize
                )

                thumbnailBytes = canvas.toDataURL()
                resolve()
            }

            video.onerror = function(e) {
                reject(new Error('Error al generar el thumbnail del video'))
            }

            video.src = base64Video
        }).catch(() => {
        })

        return thumbnailBytes
    }

    async thumbnailifyFromBlob(blob) {
        if (blob.type.startsWith('image/')) {
            const base64Image = window.URL.createObjectURL(blob)
            const thumbnail = await this.thumbnailify(base64Image)
            return thumbnail
        } else if (blob.type.startsWith('video/')) {
            const base64Video = window.URL.createObjectURL(blob)
            const thumbnail = await this.thumbnailifyVideo(base64Video)
            return thumbnail
        }
    }
}

export const ATTACHMENT_ENTITY_TYPE = {
    PATIENT: 'PATIENT',
    REQUEST: 'REQUEST',
    CASE: 'CASE',
    SAMPLE: 'SAMPLE',
    PORTION: 'PORTION',
    SUBPORTION: 'SUBPORTION',
    INCIDENT: 'INCIDENT',
    COMPLEMENTARY: 'COMPLEMENTARY',
    SYNOPTIC_TEMPLATE: 'SYNOPTIC_TEMPLATE',
    USERAPP: 'USERAPP',
    LABORATORY: 'LABORATORY'
}
